import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import image from '../../img/About/Reviews/image.png';
import icon_01 from '../../img/About/Reviews/icon_01.png';
import icon_02 from '../../img/About/Reviews/icon_02.png';
import icon_03 from '../../img/About/Reviews/icon_03.png';
import icon_04 from '../../img/About/Reviews/icon_04.png';
import icon_05 from '../../img/About/Reviews/icon_05.png';
import icon_06 from '../../img/About/Reviews/icon_06.png';
import icon_07 from '../../img/About/Reviews/icon_07.png';
import stars_3 from '../../img/About/Reviews/stars_3.svg';
import stars_4 from '../../img/About/Reviews/stars_4.svg';
import stars_5 from '../../img/About/Reviews/stars_5.svg';
import arrow_left from '../../img/About/Reviews/arrow_left.svg';
import arrow_right from '../../img/About/Reviews/arrow_right.svg';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";

const cards = [
    {
        icon: icon_01,
        stars: stars_5,
        name: 'TraderVlad93',
        desc: 'about.card_01.desc',
    },
    {
        icon: icon_02,
        stars: stars_4,
        name: 'CryptoAnna',
        desc: 'about.card_02.desc',
    },
    {
        icon: icon_03,
        stars: stars_5,
        name: 'FXHunter007',
        desc: 'about.card_03.desc',
    },
    {
        icon: icon_04,
        stars: stars_3,
        name: 'Boris_Tech',
        desc: 'about.card_04.desc',
    },
    {
        icon: icon_05,
        stars: stars_5,
        name: 'MariaInvests',
        desc: 'about.card_05.desc',
    },
    {
        icon: icon_06,
        stars: stars_4,
        name: 'DenVolk',
        desc: 'about.card_06.desc',
    },
    {
        icon: icon_07,
        stars: stars_3,
        name: 'NightScalp',
        desc: 'about.card_07.desc',
    },
];

const Reviews = () => {
    const { t } = useTranslation();
    // eslint-disable-next-line
    const [swiper, setSwiper] = useState({});
    const swiperRef = useRef(null);
    return (
        <section className="relative open-sans pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px]">
                <div className="md:grid items-center flex flex-col grid-cols-2 gap-0 md:gap-[40px] xl:gap-[95px]">
                    <div>
                        <h2 className="text-[#0C2780] font-[700] text-[28px] xl:text-[45px]">
                            {t('about.reviews.title')}
                        </h2>
                        <h4 className="mt-[20px] md:mt-[15px] sm:text-[19px] text-[14px] text-[#0C2780] font-[600]">
                            {t('about.reviews.subtitle')}
                        </h4>
                        <p className="mt-[13px] md:mt-[15px] max-w-[100%] md:max-w-[489px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                            {t('about.reviews.text')}
                        </p>
                    </div>
                    <div className="hidden md:flex justify-center items-center md:mt-0 mt-[45px]">
                        <img className="w-[100%] md:max-w-[523px] sm:max-w-[340px] max-w-[256px]" src={image} alt='' />
                    </div>
                </div>
                <div>
                    <div className="mt-[33px] md:mt-[90px] xl:mt-[160px]">
                        <Swiper
                            ref={swiperRef}
                            modules={[Navigation]}
                            style={{ overflow: 'visible' }}
                            grabCursor
                            pagination
                            spaceBetween={30}
                            slidesPerView={1}
                            onInit={(e) => { setSwiper(e) }}
                            breakpoints={{
                                650: {
                                    slidesPerView: 2,
                                },
                                992: {
                                    slidesPerView: 3,
                                },
                            }}
                        >
                            {cards.map((card, index) =>
                                <SwiperSlide key={index} className="" style={{ height: 'auto' }}>
                                    <div className="h-[100%] rounded-[20px] bg-[#CFE0F2] sm:p-[20px] py-[20px] px-[10px]" key={index}>
                                        <div className="flex items-center gap-[20px]">
                                            <img className="w-[60px]" src={card.icon} alt='' />
                                            <div className="flex flex-col gap-[10px] items-start">
                                                <h4 className="sm:text-[19px] text-[16px] text-[#0C2780] font-[600]">
                                                    {card.name}
                                                </h4>
                                                <img className="h-[16px]" src={card.stars} alt='' />
                                            </div>
                                        </div>
                                        <p className="mt-[20px] max-w-[100%] md:max-w-[489px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                                            {t(card.desc)}
                                        </p>
                                    </div>
                                </SwiperSlide>
                            )}
                        </Swiper>
                    </div>
                    <div className="flex content-end justify-end sm:mt-[25px] mt-[15px] gap-[20px]">
                        <div className="w-[38px] cursor-pointer hover:opacity-70 duration-150" onClick={() => swiperRef.current.swiper.slidePrev()}>
                            <img src={arrow_left} alt='' />
                        </div>
                        <div className="w-[38px] cursor-pointer hover:opacity-70 duration-150" onClick={() => swiperRef.current.swiper.slideNext()}>
                            <img src={arrow_right} alt='' />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default Reviews;
